<!--
* 组件名 : 轮播器卡片
* 开发者 : JY
*
* 参数:
*   data     { Object } -  每个卡片数据
*
* 事件: null
*
*
-->

<template>
  <div class="v-picture-items" v-styles:[callback]="image" ref="pictureItems">
    <img :src="image" />
  </div>
</template>

<script>
import { renderImage, i18n } from "utils/util";
import debounce from "debounce";
export default {
  name: "picture-items",
  props: {
    data: {
      type: Object,
      required: true,
    },
    dataType: {
      type: "",
      required: true,
    },
  },
  data() {
    let self = this;

    this.callback = {
      on_update() {
        self.$emit("update");
      },
    };
    return {
      image: i18n(
        `images/spread-of-kingdom-gospel/${this.$route.name}/${
          this.dataType ? "God-chosen-people-various-countries" : "news"
        }/${this.data.poster}`
      ),
    };
  },
  directives: {
    styles: {
      // 指令的定义
      bind: (el, { arg, value }) => {
        renderImage(value).then((img) => {
          let prop = (img.width / img.height).toFixed(2);
          el.style.width = `${prop * el.offsetHeight}px `;
          el.setAttribute("prop", prop);
          arg.on_update();
        });
      },
    },
  },

  mounted() {
    $(window).on(
      "resize",
      debounce(() => this.monitor_picture_size(), 200)
    );
  },

  methods: {
    monitor_picture_size() {
      $(this.$refs.pictureItems).map((i, item) => {
        let prop = item.getAttribute("prop");
        item.style.width = `${prop * item.clientHeight}px `;
      });
    },
  },
};
</script>

<style lang="scss">
.v-picture-items {
  height: 336px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.25);
    pointer-events: none;
    transition: opacity 0.3s;
  }

  &.swiper-slide {
    width: auto;
    transform: scale(0.8);
    transition: transform 0.45s ease-in-out;
    margin: 0 30px;
    border-radius: 8px;
    overflow: hidden;

    &.swiper-slide-active {
      transform: scale(1);
      &::before {
        opacity: 0;
      }
    }

    img {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
    }
  }

  @media (min-width: $lx-min) {
    height: 452px;
  }
}
</style>
